import { isArray } from 'util';
import { mapCollection } from '../../utils/collection.utils';
import { SaleOfferDeparture } from '../sale-offer-departure';
import { parseNumber } from '../../utils/number.utils';
import { SaleOfferDepartureSerialNumberBuilder } from './sale-offer-departure-serial-number.builder';

export class SaleOfferDepartureBuilder {
  static fromJson(json): SaleOfferDeparture {
    return (json) ? new SaleOfferDeparture(
      json.hash,
      parseNumber(json.departureDate),
      json.authorizingPersonHash,
      json.authorizingPersonName,
      json.requestMadeByHash,
      json.requestMadeByName,
      json.saleOfferDepartureReasonHash,
      json.saleOfferDepartureReasonName,
      json.observations,
      (isArray(json.saleOfferDepartureSerialNumbers)) ?
        SaleOfferDepartureSerialNumberBuilder.fromJsonList(json.saleOfferDepartureSerialNumbers) : [],
      parseNumber(json.duration),
      parseNumber(json.durationDate)
    ) : null;
  }

  static fromJsonList(list): SaleOfferDeparture[] {
    return (isArray(list)) ? mapCollection(SaleOfferDepartureBuilder.fromJson, list) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-departure-builder.ts